/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as t from "react";
import { GridColumnMenuWrapper as d } from "../columnMenu/GridColumnMenuWrapper.mjs";
import { selectRow as c, messages as m } from "../messages/index.mjs";
import { useLocalization as u } from "@progress/kendo-react-intl";
import { useId as s } from "@progress/kendo-react-common";
import { GridContext as k } from "../GridClientWrapper.mjs";
const b = (e) => {
  const o = t.useContext(k), a = s(), r = u(), i = e.id || a, n = [
    /* @__PURE__ */ t.createElement("span", { key: 0, className: "k-checkbox-wrap" }, /* @__PURE__ */ t.createElement(
      "input",
      {
        id: i,
        type: "checkbox",
        tabIndex: -1,
        className: "k-checkbox k-checkbox-md k-rounded-md",
        "aria-label": r.toLanguageString(c, m[c]),
        "aria-checked": e.selectionValue,
        checked: e.selectionValue,
        onChange: (l) => o.onHeaderSelectionChange({
          field: e.field,
          syntheticEvent: l
        })
      }
    )),
    e.columnMenuWrapperProps.columnMenu && /* @__PURE__ */ t.createElement(d, { ...e.columnMenuWrapperProps })
  ];
  return e.render ? e.render.call(void 0, n, e) : n;
};
export {
  b as GridHeaderSelectionCell
};
